import React from "react";
import Popup from "reactjs-popup";
import { EmailCollector, MainLogo, WeChatPoster, GoogleTranslate } from "./";
import { Link } from "gatsby";

interface BottomNavOption {
  to: string;
  text: string;
  external?: boolean;
}

interface SocialMediaButtons {
  name: string;
  link: string;
  viewBox: [number, number];
  iconPaths: string[];
}

const bottomNavOptions: BottomNavOption[] = [
  {
    to: "/products",
    text: "Products",
  },
  {
    to: "/contact",
    text: "Contact Us",
  },
  // {
  //   external: true, // ToDo: This entry has to be changed.
  //   to: "https://manisgoyal.github.io",
  //   text: "Affiliates",
  // },
];

const mediaLinks: SocialMediaButtons[] = [
  {
    name: "Facebook",
    link: "https://www.facebook.com/people/Iconic-Rain/61559283080412/",
    viewBox: [96.227, 96.227],
    iconPaths: [
      "M73.099,15.973l-9.058,0.004c-7.102,0-8.477,3.375-8.477,8.328v10.921h16.938l-0.006,17.106H55.564v43.895H37.897V52.332   h-14.77V35.226h14.77V22.612C37.897,7.972,46.84,0,59.9,0L73.1,0.021L73.099,15.973L73.099,15.973z",
    ],
  },
  {
    name: "Whatsapp",
    link: "https://wa.me/+8615724926443",
    viewBox: [308, 308],
    iconPaths: [
      "M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156   c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687   c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887   c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153   c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348   c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802   c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922   c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0   c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458   C233.168,179.508,230.845,178.393,227.904,176.981z",
      "M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716   c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396   c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z    M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188   l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677   c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867   C276.546,215.678,222.799,268.994,156.734,268.994z",
    ],
  },
];

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="mx-auto w-full max-w-screen-xl">
        <div className="grid grid-cols-1 gap-8 px-4 py-6 lg:py-8 md:grid-cols-[1fr_1fr_1fr]">
          <div className="notranslate mx-auto md:mx-0">
            <MainLogo iconTextFill="white" />
            <p className="mb-4 notranslate">Shade Your Day, Rain or Shine</p>
            <div className="flex flex-col">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="tel:+86-15724926443"
              >
                +86-15724926443
              </a>

              <a
                rel="noopener noreferrer"
                target="_blank"
                href="mailto:contact@iconicrain.com"
              >
                contact@iconicrain.com
              </a>
              <div>
                {mediaLinks.map((value, index) => (
                  <a
                    key={index}
                    href={value.link}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="mr-2"
                  >
                    <button className="bg-white rounded p-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        fill="#000"
                        version="1.1"
                        viewBox={`0 0 ${value.viewBox[0]} ${value.viewBox[1]}`}
                        xmlSpace="preserve"
                      >
                        {value.iconPaths.map((path) => (
                          <path d={path}></path>
                        ))}
                      </svg>
                    </button>
                  </a>
                ))}
                <Popup
                  trigger={
                    <button className="bg-white rounded p-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        fill="#000"
                        version="1.1"
                        viewBox="0 0 32 32"
                        xmlSpace="preserve"
                      >
                        <path d="m11.1193503 8.98884181c0 .97457627-.7909605 1.76553669-1.76553674 1.76553669-.97457627 0-1.76553672-.79096042-1.76553672-1.76553669s.79096045-1.76553673 1.76553672-1.76553673c.97457624 0 1.76553674.79096046 1.76553674 1.76553673zm7.1327683 1.76553669c.9745763 0 1.7655368-.79096042 1.7655368-1.76553669s-.7909605-1.76553673-1.7655368-1.76553673c-.9745762 0-1.7655367.79096046-1.7655367 1.76553673s.7909605 1.76553669 1.7655367 1.76553669zm10.6603108 17.1327684.3990113 3.8665254-3.5310735-1.8891243c-1.3629943.5649718-2.8813559.8792373-4.4879943.8792373-4.9823447 0-9.1596045-3.0367232-10.289548-7.1292373-.960452-.1694915-1.88559326-.4272599-2.76129948-.7591808l-4.00423728 2.1433616.42725988-4.1172316c-2.83898305-2.1680791-4.63276836-5.3319209-4.63276836-8.8524012 0-6.53248583 6.16525424-11.829096 13.77118644-11.829096s13.7711864 5.29661017 13.7711864 11.829096c0 .5861582-.049435 1.1617232-.144774 1.726695 2.7012712 1.6949152 4.4597458 4.4809322 4.4597458 7.6306497 0 2.5247175-1.1334746 4.8199152-2.9766949 6.5007062zm-20.0423729-6.684322c.60028248.2259887 1.2146893.4096045 1.8396893.5508474-.0070622-.1235876-.0105933-.2436441-.0105933-.3672316 0-5.1694915 4.7422317-9.3573447 10.5932204-9.3573447 1.5960452 0 3.1108757.3107345 4.4668079.8721752.0282486-.286017.0459039-.5790961.0459039-.8721752 0-5.54731634-5.384887-10.06355928-12.0056497-10.06355928-6.62076268 0-12.00564969 4.51624294-12.00564969 10.06355928 0 1.4265537.34957627 2.8072034 1.04166667 4.1031074.68149717 1.2747175 1.65607344 2.4011299 2.8990113 3.3474576l.78742938.6002825-.10240113.9851695-.08474577.8086158 1.06991526-.5720339.70974576-.3778248zm18.3545198-7.5706215c.0670904.0388418.1341808.0812147.2012712.1235876-.0670904-.0423729-.1341808-.0847458-.2012712-.1235876zm-.2012712-.1200565c.0321428.03125.0678571.06875.1.1-.0357143-.03125-.0678572-.06875-.1-.1zm-.2048023-.1129944c.0333334.03.0666667.07.1.1-.0333333-.03-.0666666-.07-.1-.1zm-.2048022-.0965254c.0363636.02.0636363.04.1.06-.0363637-.02-.0727273-.04-.1-.06zm-.1953955-.0926977.06.03zm-.1989266-.0924012c.01 0 .01.01.02.01 0-.01-.01-.01-.02-.01zm3.9042091 8.2689125c0-4.1878531-3.9583334-7.5918079-8.8276836-7.5918079-4.8693503 0-8.8276837 3.4039548-8.8276837 7.5918079s3.9583334 7.5918079 8.8276837 7.5918079c1.3347457 0 2.6165254-.2507062 3.8100282-.7450565l.7733051-.3177966.7379943.3954802.5967515.3213277-.0564972-.5579096-.0918079-.8862994.6567796-.6002825c1.5466102-1.4194916 2.40113-3.266243 2.40113-5.2012712zm-12.2175142-3.3050848c-.7803672 0-1.4124293.6320622-1.4124293 1.4124294s.6320621 1.4124294 1.4124293 1.4124294c.7803673 0 1.4124294-.6320622 1.4124294-1.4124294s-.6320621-1.4124294-1.4124294-1.4124294zm6.7796611 0c-.7803673 0-1.4124294.6320622-1.4124294 1.4124294s.6320621 1.4124294 1.4124294 1.4124294c.7803672 0 1.4124293-.6320622 1.4124293-1.4124294s-.6320621-1.4124294-1.4124293-1.4124294z"></path>
                      </svg>
                    </button>
                  }
                  modal
                >
                  {
                    // Ignore this LSP Error
                    (close: () => void) =>
                      (<WeChatPoster close={close} />) as React.ReactNode
                  }
                </Popup>
              </div>
            </div>
          </div>
          <div className="mx-auto px-7">
            <ul className="font-medium">
              {bottomNavOptions.map((value, index) => (
                <li key={index} className="mb-4 hover:underline">
                  {!value.external ? (
                    <Link to={value.to} activeClassName="underline">
                      {value.text}
                    </Link>
                  ) : (
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href={value.to}
                    >
                      {value.text}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="p-2">
              Join our Newsletter for new product catalogs and specifications.
            </p>
            <div>
              <EmailCollector collectorType="form" postLink="/emailCollector" />
            </div>
          </div>
        </div>
      </div>
      <hr className="h-1 text-[#000] bg-[#000]" />
      <div className="px-4 py-1 text-grayish">
        <div className="mx-auto w-full max-w-screen-xl md:flex md:items-center md:justify-between">
          <span className="text-sm sm:text-center notranslate">
            © 2024 <Link to="/">Iconic Rain™</Link>. All Rights Reserved.
          </span>

          <div className="flex mt-4 sm:justify-center md:mt-0 space-x-5 rtl:space-x-reverse">
            <GoogleTranslate />
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
